import React from "react";
import headingImg from "../../assets/img/heading-img.png";
import courseImg1 from "../../assets/img/course1.jpg";
import courseImg2 from "../../assets/img/course2.png";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Courses.css";

const Courses = () => {
  return (
    <div id="courses">
      <section className="our-courses-section gap">
        <div className="container">
          <div className="heading">
            <img src={headingImg} alt="icon" />
            <p>Islamic Classes and Courses</p>
            <h2>Our Courses</h2>
          </div>
          <div className="row">
            <div className="col-lg-3 col-sm-6">
              <div className="courses">
                <div className="courses-img">
                  <figure>
                    <img src={courseImg1} alt="img" />
                  </figure>
                  <a href="#">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </a>
                </div>
                <div className="scholar">
                  <div>
                    <h4>Habib Al Noor</h4>
                    <span>Arabic scholar</span>
                  </div>
                </div>
                <div className="courses-text">
                  <a href="#">Quran Intermediate Course Brother</a>
                  <h4>$16.00</h4>
                  <span>Course Fee</span>
                </div>
                <div className="courses-weeks">
                  <h6>10 weeks</h6>
                  <div className="border"></div>
                  <h6>50 enroll</h6>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="courses">
                <div className="courses-img">
                  <figure>
                    <img src={courseImg2} alt="img" />
                  </figure>
                  <a href="#">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </a>
                </div>
                <div className="scholar">
                  <div>
                    <h4>Habib Al Noor</h4>
                    <span>Arabic scholar</span>
                  </div>
                </div>
                <div className="courses-text">
                  <a href="#">Quran Intermediate Course Brother</a>
                  <h4>$16.00</h4>
                  <span>Course Fee</span>
                </div>
                <div className="courses-weeks">
                  <h6>10 weeks</h6>
                  <div className="border"></div>
                  <h6>50 enroll</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Courses;
